/**
 * Date/Time & Timezone Utilities
 *
 * Golden Rule: Store UTC, Display in Event's Timezone
 *
 * @example
 * import { detectTimezone, formatEventDate, DATE_FORMATS } from '@/utils/dateTime'
 */

// Constants
export {
  TIMEZONES,
  COMMON_TIMEZONES,
  COMPACT_TIMEZONES,
  DATE_FORMATS,
  MIN_EVENT_DAYS,
  DEFAULT_EVENT_DAYS,
} from './constants'

// Timezone detection & management
export {
  getUserTimezone,
  getCurrentDateTime,
  detectTimezone,
  getCachedTimezone,
  clearCachedTimezone,
  getTimezoneOffset,
  isValidTimezone,
} from './timezone'

// User input ↔ API conversion
export {
  convertLocalToUTC,
  parseUTCToLocal,
  prepareDateForApi,
  validateDateInput,
} from './convert'

// Display formatting
export {
  formatEventDate,
  formatInUserTimezone,
  getRelativeTime,
  formatRelativeTime,
  formatDateShort,
  formatDuration,
} from './format'

// Helpers
export {
  hasExpired,
  createExpiryDate,
  parseUTCDate,
  roundToTenMinutes,
  toEventLocalDate,
  getMinEventDate,
  getDefaultEventDateTime,
  calendarDaysUntil,
} from './helpers'
